import { render, staticRenderFns } from "./MerchantAccountsTrusting.vue?vue&type=template&id=9c3fcc80&scoped=true&"
import script from "./MerchantAccountsTrusting.vue?vue&type=script&lang=js&"
export * from "./MerchantAccountsTrusting.vue?vue&type=script&lang=js&"
import style0 from "./MerchantAccountsTrusting.vue?vue&type=style&index=0&id=9c3fcc80&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c3fcc80",
  null
  
)

export default component.exports